import map from "lodash/fp/map";
import isNil from "lodash/fp/isNil";
import startCase from "lodash/fp/startCase";
import constants from "../../core/constants";
import moment from "moment";
class DispatchersPageTransform {
  constructor() {
    "ngInject";

    this.fields = [
      { title: "Creation Date", name: "creation_date" },
      { title: "Category", name: "category_name" },
      { title: "Total", name: "total_schedules" },
      { title: "Successful", name: "successful_rides_count" },
      { title: "Already Dispatched", name: "skipped_rides_count" },
      { title: "Failed", name: "failed_schedules_count" },
      { title: "In Progress", name: "in_queue_schedules_count" },
      { title: "Dispatching Date", name: "dispatcher_meta_date" },
      { title: "Dispatching City", name: "city_name" },
      { title: "ID", name: "dispatcher_meta_uuid" },
    ];
    this.filters = [
      {
        name: "created_at",
        title: "Creation Date",
        icon: "date_range",
        isDate: true,
        hasRange: false,
      },
      {
        name: "date",
        title: "Dispatching Date",
        icon: "date_range",
        isDate: true,
        hasRange: false,
      },
      { name: "city", title: "City", icon: "location_city", resource: "City" },
      {
        name: "category",
        title: "Ride Category",
        icon: "directions_car",
        list: "rideCategoryList",
        multiple: true,
      },
    ];
    this.filters = [
      {
        name: "created_at",
        title: "Creation Date",
        icon: "date_range",
        isDate: true,
        hasRange: false,
      },
      {
        name: "date",
        title: "Dispatching Date",
        icon: "date_range",
        isDate: true,
        hasRange: false,
      },
      { name: "city", title: "City", icon: "location_city", resource: "City" },
      {
        name: "category",
        title: "Ride Category",
        icon: "directions_car",
        list: "rideCategoryList",
        multiple: true,
      },
    ];
  }

  justify(data) {
    const format = (item) => {
      item.creation_date = moment(item.createdAt).format(
        constants.dateTimeFormat
      );
      item.city_name = item.city ? item.city.name : "-";
      item.category_name = item.ride_category
        ? `${startCase(item.ride_category.ride_type)} ${startCase(
            item.ride_category.service_type
          )}`
        : "";
      item.dispatcher_meta_date = moment(item.dispatcher_meta.date).format(
        `${constants.dayFullName} | ${constants.dateTimeFormat}`
      );

      item.dispatcher_meta_uuid = isNil(item.dispatcher_meta.uuid)
        ? ""
        : item.dispatcher_meta.uuid.match(/\w+$/)[0];
      return item;
    };
    return map(format)(data);
  }
}

export default DispatchersPageTransform;



// WEBPACK FOOTER //
// ./src/pages/dispatchers/dispatchers.transforms.js